import React from "react";
import { NavLink } from "react-router-dom";
export class Menu extends React.Component {
  render() {
    const menuItems = this.props.mainMenu;
    const listItems = menuItems.map((item, index) => (
      <li key={index}>
        <NavLink
          onClick={this.props.closeMenu}
          activeClassName="active"
          to={`/${item.object_slug}`}
        >
          {item.title}
        </NavLink>
      </li>
    ));
    return <ul className="main-menu">{listItems}</ul>;
  }
}



// WEBPACK FOOTER //
// ./src/Menu.js